// extracted by mini-css-extract-plugin
export default {"ChipsReadonly":"styles_ChipsReadonly__g1lzI","header":"styles_header__n8Ixi","label":"styles_label__M6+G2","field":"styles_field__LZj9w","chip":"styles_chip__9jpIx"};